import cn from 'classnames'
import React, { useContext } from 'react'

//
import { SectionHeader, SectionImage, SimpleContentBlock } from '../../../storybook'
import { THEME } from '@/src/utils/common'
import { SiteDataContext } from '../../page-wrapper'

const BlockSummary = ({
  data: {
    title,
    preface,
    theme = THEME.light,
    imageBackgroundColor,
    image,
    simpleContentBlocks = []
  }
}) => {
  const { isTextRtl } = useContext(SiteDataContext)
  return (
    <section
      className={cn('l-section l-section--force-padding', {
        'l-section--dark': theme === THEME.dark
      })}
      dir={isTextRtl ? 'rtl' : 'ltr'}
    >
      <div className="l-section__content">
        <div className="l-container:12/12 l-container--default-spacing">
          <div className="l-grid l-grid--default-spacing l-grid--align:middle">
            <div className="l-grid l-grid__col:12/12 l-grid__col:6/12@at:viewport-7">
              <SectionImage image={image} imageBackgroundColor={imageBackgroundColor} />
            </div>

            <div className="l-grid__col:6/12 l-grid__col:12/12@to:viewport-7">
              <div>
                <SectionHeader
                  eyebrow={preface}
                  title={title}
                  headingType="h2"
                  inverted={theme === THEME.dark}
                />
              </div>

              <div className="u-margin-top:16 block-summary-simple-blocks-container">
                {simpleContentBlocks &&
                  simpleContentBlocks.map((item, i) => {
                    return (
                      <SimpleContentBlock
                        key={i}
                        icon={item.icon}
                        bulletListColor={item.bulletListColor}
                        title={item.title}
                        description={item.description}
                        action={item.action}
                        theme={theme}
                      />
                    )
                  })}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}

export default BlockSummary
